/**
 * external libs
 */
import React from 'react';
/**
 * components
 */
import WidgetImage from "../Widget/components/WidgetImage";
import WidgetFile from "../Widget/components/WidgetFile";
import getWidget from "../../utils/getWidget";

export default function Avatar({ avatarResult, field, firstName, lastName , fontSize = '24px' , background = 'lightblue'}) {
    const firstInitial = firstName?.measures?.[0] ?? firstName?.measures?.string?.[0] ?? '';
    const lastInitial = lastName?.measures?.[0] ?? lastName?.measures?.string?.[0] ?? '';
    if (!avatarResult || !avatarResult.measures?.[field]) {
        return (
            <div style={{
                width: "100%",
                height: "100%",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: background,
                color: 'white',
                fontSize: fontSize,
                fontWeight: 'bold'
            }}>
                {`${firstInitial}${lastInitial}`.toUpperCase()}
            </div>
        );
    }


    return <img src={avatarResult.measures.url.url} style={{width: "100%", height: "100%", objectFit: "cover"}} alt=""/>
    return <WidgetFile result={avatarResult} tooltipShow={false} widget={getWidget(avatarResult)} field={field} canBeLink={false} />;
}
